import BaseApiManager from '../../user/api/managers/BaseApiManager'

/**
 * Undesirable Behavior API Manager.
 */
export default class UndesirableBehaviorApiManager extends BaseApiManager {

  /**
   * Finds undesirable behavior by Client ID.
   *
   * @param {Number} clientId
   * @param {Number} perPage
   * @param {Number} page
   * @param {String} sort
   * @param {String} search
   * @returns {Promise<any>}
   */
  async findByClientId(clientId, protocolId,antecedentId, behaviorId, perPage = 10, page = 1, startDate, endDate, sort, search) {

      let url = `${this.url}/${clientId}/${perPage}/${page}`;
      return await this.axios.get(url, {
          params: {
              antecedentId: antecedentId,
              behaviorId: behaviorId,
              protocolId: protocolId,
              startDate: startDate,
              endDate: endDate,
          },
      })
  }


  /**
   *
   * @param clientId
   * @param perPage
   * @param page
   * @param startDate
   * @param endDate
   * @param frequencyType
   */
  async findByClientIdGroupedByFrequency(clientId, perPage = 10, page = 1, startDate, endDate, frequencyType) {
    let url = `${this.url}/frequency/${clientId}/${perPage}/${page}/${frequencyType}`;

    return await this.axios.get(url, {
      params: {
        startDate,
        endDate,
      },
    })
  }

  /**
   * Create new undesirable behavior.
   *
   * @param {Number} clientId
   * @param {String} antecedent
   * @param {String} behavior
   * @param {String} effects
   * @returns {Promise<any>}
   */
  async create (clientId, antecedentTypes, behaviorTypes, effectsTypes, consequenceInBehaviorTypes, entity, createdAt) {
      //let createdAt = Math.round((new Date()).getTime() / 1000);

      if (entity && Object.keys(entity).length !== 0) {
          return await this.axios.post(
              this.url, {
                  clientId,
                  antecedentTypes,
                  behaviorTypes,
                  effectsTypes,
                  consequenceInBehaviorTypes,
                  entity,
                  createdAt
              },
          )
      } else {
          return await this.axios.post(
              this.url, {
                  clientId,
                  antecedentTypes,
                  behaviorTypes,
                  effectsTypes,
                  consequenceInBehaviorTypes,
                  createdAt
              },
          )
      }
  }

    /**
     * Get types by Client ID.
     *
     * @param {Number} clientId
     * @returns {Promise<any>}
     */
    async getTypes(clientId) {
        return await this.axios.get(`${this.url}/units/types/${clientId}`, {
            clientId
        })
    }

    /**
     * Create new types.
     *
     * @param {Number} clientId
     * @param {Array} types
     * @returns {Promise<any>}
     */
    async saveTypes(clientId, antecedentTypes, behaviorTypes, effectsTypes, consequenceInBehaviorTypes) {
        let createdAt = Math.round((new Date()).getTime() / 1000);
        return await this.axios.post(`${this.url}/units/types`, {
            clientId,
            antecedentTypes,
            behaviorTypes,
            effectsTypes,
            consequenceInBehaviorTypes,
            createdAt
        })
    }

    async getCountBehavior(clientId, protocolId,antecedentId, behaviorId, startDate, endDate) {
        return await this.axios.get(`${this.url}/statistics/${clientId}`, {
            params: {
                antecedentId,
                behaviorId,
                protocolId,
                startDate,
                endDate
            },
        })
    }

    async getCountTypes(clientId, protocolId,antecedentId, behaviorId, startDate, endDate) {
        return await this.axios.get(`${this.url}/units/types/statistics/${clientId}`, {
            params: {
                antecedentId,
                behaviorId,
                protocolId,
                startDate,
                endDate
            },
        })
    }

    async getScatterplotData(clientId, protocolId,antecedentId, behaviorId, startDate, endDate) {
        return await this.axios.get(`${this.url}/scatterplot/${clientId}`, {
            params: {
                antecedentId,
                behaviorId,
                protocolId,
                startDate,
                endDate
            },
        })
    }

    async getAncedents(clientId, protocolId, skillFieldId, perPage = 10, page = 1, startDate, endDate) {
        let url = `${this.url}/antecedents/${clientId}/${perPage}/${page}/`;

        return await this.axios.get(url, {
            params: {
                protocolId,
                skillFieldId,
                startDate,
                endDate,
            },
        })
    }

    async getBehaviors(clientId, protocolId, skillFieldId, perPage = 10, page = 1, startDate, endDate) {
        let url = `${this.url}/behaviors/${clientId}/${perPage}/${page}/`;

        return await this.axios.get(url, {
            params: {
                protocolId,
                skillFieldId,
                startDate,
                endDate,
            },
        })
    }

    async getUBsList(clientId, protocolId, skillFieldId, perPage = 10, page = 1, startDate, endDate) {
        let url = `${this.url}/behaviors/${clientId}/${perPage}/${page}/`;

        return await this.axios.get(url, {
            params: {
                protocolId,
                skillFieldId,
                startDate,
                endDate,
            },
        })
    }



}



// WEBPACK FOOTER //
// ./src/modules/undesirableBehavior/api/UndesirableBehaviorApiManager.ts